import { render, staticRenderFns } from "./pi-list-match.vue?vue&type=template&id=2a4e3d16"
import script from "./pi-list-match.vue?vue&type=script&lang=ts"
export * from "./pi-list-match.vue?vue&type=script&lang=ts"
import style0 from "./pi-list-match.vue?vue&type=style&index=0&id=2a4e3d16&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports